package com.rainbowclubs.rainbow.presentation.splash

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import rainbowclubs.composeapp.generated.resources.Res
import rainbowclubs.composeapp.generated.resources.logo_image_cd
import rainbowclubs.composeapp.generated.resources.rainbow_clubs

@Composable
fun SplashScreen(
    viewModel: SplashViewModel = koinViewModel(),
    onLoadingFinished: (SplashNavigationEvent) -> Unit,
) {
    LaunchedEffect(Unit) {
        viewModel.navigate()
        viewModel.navigationIntent.collect {
            onLoadingFinished(it)
        }
    }

    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            painter = painterResource(Res.drawable.rainbow_clubs),
            contentDescription = stringResource(Res.string.logo_image_cd),
        )
        Spacer(modifier = Modifier.height(16.dp))
        CircularProgressIndicator()
    }
}

@Preview
@Composable
private fun SplashScreenPreview() {
    SplashScreen(
        onLoadingFinished = {},
    )
}
